import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from '../services/date/date.service';

@Pipe({ name: 'dateConversion',pure:false })
export class DateConversionPipe implements PipeTransform {
  constructor(private dateService:DateService){

  }
  transform(details: any,upperCase:boolean, deliveryType?:string, index?:number, dayOnly?:boolean) {
    return this.dateService.formatDetailsToShortDate(details,upperCase, deliveryType, index,dayOnly);
  }
}